import { BrowserRouter } from 'react-router-dom';
import LanguageRedirectHandler from './LanguageRedirectHandler';

export const RouterProvider = ({ children }) => {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_skipActionErrorRevalidation: true,
      }}
    >
      <LanguageRedirectHandler>
        {children}
      </LanguageRedirectHandler>
    </BrowserRouter>
  );
};

